module.exports = __webpack_public_path__ + "static/img/hx8.64a88cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx8.png
// module id = byd5
// module chunks = 1